export default __webpack_public_path__ + "static/media/FlapPink_diffuse-min.710ad625.jpg";